import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import { UserTypeSection } from './steps/user-type-section';
import { scrollToTop } from '../../../utils/general';
import { PaymentPermissionsSection } from './steps/payment-permissions-section';
import { FooterButtons } from './footer-buttons';
import { useManageUserForm } from '../../../hooks/use-manage-user-form';
import { ERR_UNABLE_TO_ADD_OR_EDIT_USER } from '../../../constants/response-error-messages';
var EditUserFormContent = function (_a) {
    var onCancel = _a.onCancel, isEditUserError = _a.isEditUserError;
    var _b = useManageUserForm(), steps = _b.steps, dispatch = _b.dispatch, editableUser = _b.editableUser;
    var userTypeStep = steps[1], paymentPermissionsStep = steps[2], reviewStep = steps[3];
    return (React.createElement("div", { className: "sui-col-span-12 md:sui-col-span-6 2xl:sui-col-span-4" },
        React.createElement("div", { className: "sui-mb-6 sui-flex sui-flex-row sui-justify-between sui-items-baseline" },
            React.createElement(Typography, { variant: "h2" }, "Edit User"),
            React.createElement(Link, { "data-testid": "header-cancel-btn", onClick: onCancel }, "Cancel")),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement(Typography, { variant: "h5" }, "User Details"),
            editableUser && (React.createElement("div", null,
                React.createElement(Typography, null,
                    React.createElement("span", { className: "sui-capitalize" }, "".concat(editableUser.firstName, " ").concat(editableUser.lastName))),
                React.createElement(Typography, null, editableUser.email)))),
        userTypeStep.state !== 'HIDDEN' && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: "sui-h-px sui-bg-gray-200 sui-border-1" }),
            React.createElement(UserTypeSection, { isActive: userTypeStep.state === 'ACTIVE', isCompleted: userTypeStep.state === 'COMPLETED', shouldDisableEditing: paymentPermissionsStep.state === 'ACTIVE', continueHandler: function () {
                    scrollToTop();
                    dispatch({
                        type: 'COMPLETE',
                        target: 'USER_TYPE',
                    });
                }, editHandler: function () {
                    dispatch({
                        type: 'ACTIVATE',
                        target: 'USER_TYPE',
                    });
                    dispatch({
                        type: 'DEACTIVATE',
                        target: 'REVIEW',
                    });
                }, cancelHandler: function () {
                    onCancel();
                } }))),
        paymentPermissionsStep.state !== 'HIDDEN' && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: "sui-h-px sui-bg-gray-200 sui-border-1" }),
            React.createElement(PaymentPermissionsSection, { isActive: paymentPermissionsStep.state === 'ACTIVE', isCompleted: paymentPermissionsStep.state === 'COMPLETED', shouldDisableEditing: userTypeStep.state === 'ACTIVE', continueHandler: function () {
                    dispatch({
                        type: 'COMPLETE',
                        target: 'PAYMENT_PERMISSIONS',
                    });
                }, editHandler: function () {
                    dispatch({
                        type: 'ACTIVATE',
                        target: 'PAYMENT_PERMISSIONS',
                    });
                    dispatch({
                        type: 'DEACTIVATE',
                        target: 'REVIEW',
                    });
                }, cancelHandler: function () {
                    onCancel();
                } }))),
        isEditUserError && (React.createElement("div", { "data-testid": "edit-user-error", className: "sui-pt-4" },
            React.createElement(Alert, { status: "error" }, ERR_UNABLE_TO_ADD_OR_EDIT_USER.message))),
        reviewStep.state === 'ACTIVE' && (React.createElement("div", { className: "sui-pt-8" },
            React.createElement(FooterButtons, { continueText: "Save Changes", type: "submit", cancelHandler: onCancel })))));
};
EditUserFormContent.displayName = 'EditUserFormContent';
export default EditUserFormContent;
